import { ButtonBar, FilterChange } from '@starryui10/grids/buttonBar/ButtonBar';
import { IManagedColumn, ManageColumnButton } from '@starryui10/grids/buttonBar/ManageColumnButton';
import { RefreshButton } from '@starryui10/grids/buttonBar/RefreshButton';
import React from 'react';
import { ExportDirectory } from '../../components/ExportDirectory';
import { useDirectoryDispatch, useDirectoryState } from '../../state/DirectoryState';
import { useColumnsProviderContext } from './ColumnsProvider';

export interface IAppButtonBarProps {
    onColumnToggle: (col: IManagedColumn) => void;
}

export const AppButtonBar = ({ onColumnToggle }: IAppButtonBarProps) => {
    const { columns } = useColumnsProviderContext();
    const { dispatch } = useDirectoryDispatch();
    const { gridFormat } = useDirectoryState();

    const handleFilterSearchChange = (change: FilterChange) => {
        switch (change.type) {
            case 'Clear':
                dispatch({ type: 'CLEAR_FILTERS' });
                break;

            case 'Search':
                dispatch({ type: 'SEARCH', search: change.searchString });
                break;
        }
    };

    const handleOnRefresh = () => {
        dispatch({ type: 'RELOAD' });
    };

    const handleResetColumns = () => {
        dispatch({ type: 'COLUMNS_RESET_TO_DEFAULT' });
    };

    const buildColumns = () => {
        return columns
            .toArray()
            .map((e) => {
                const colFromGridFormat = gridFormat?.find((g) => g.id === e.field || g.id === e.colId);

                return {
                    caption: e.headerName,
                    field: e.field,
                    visible: colFromGridFormat ? colFromGridFormat.columnVisibility : !e.hide,
                };
            })
            .filter((e) => e.caption);
    };

    return (
        <ButtonBar OnFilterSearchChange={handleFilterSearchChange}>
            <RefreshButton disabled={false} onClick={() => handleOnRefresh()} />
            <ExportDirectory />
            <ManageColumnButton columns={buildColumns() as IManagedColumn[]} onClick={onColumnToggle} onResetColumns={handleResetColumns} />
        </ButtonBar>
    );
};
